export const permissions = {
    SEE_LOGS: "VIGIFLOW.LISTAR",
    // Permisos para ver detalles
    SEE_DETAIL_LOG: "VIGIFLOW.VER_DETALLE"
};
